import BaseService from '@/services/services/tools/baseService';
import AuthorizationsAPI from '@/services/api/internal/authorization.api';

const AuthorizationsService = new BaseService({
  api: AuthorizationsAPI,
  treatListResponse: (response) => {
    const { items } = response.data;
    const res = {};
    if (items) {
      res.isInactive = items.some(
        (item) => item.profile === 'isInactive' && item.value === 'O'
      );
      res.isDispatcher = items.some(
        (item) => item.profile === 'isDispatcheur' && item.value === 'O'
      );
      res.isPEM = items.some(
        (item) => item.profile === 'isPEM' && item.value === 'O'
      );
      res.isREE = items.some(
        (item) => item.profile === 'isREE' && item.value === 'O'
      );
      res.isMy360 = items.some(
        (item) => item.profile === 'isMy360' && item.value === 'O'
      );
      res.isMobileeRollOut = items.some(
        (item) => item.profile === 'isMobileeRollOut' && item.value === 'O'
      );
      res.hasDashboard = items.some(
        (item) => item.profile === 'hasDashboard' && item.value === 'O'
      );
      res.hasRequestCreation = items.some(
        (item) => item.profile === 'hasRequestCreation' && item.value === 'O'
      );
      res.hasTESTING = items.some(
        (item) => item.profile === 'hasTESTING' && item.value === 'O'
      );
      res.hasHIS = items.some(
        (item) => item.profile === 'isHIS' && item.value === 'O'
      );
      res.hasRegulatoryControl = items.some(
        (item) => item.profile === 'hasRegulatoryControl' && item.value === 'O'
      );
    }
    return res;
  },
  retry: { nbLeft: 3, timeout: 2000 },
});

export default AuthorizationsService;
